import { createFileRoute } from "@tanstack/react-router";

import { TemplateLibrary } from "@/features/training-plans/modules/template-library/template-library";
import { TrainingPlanKind } from "@complete-athlete/enums";

// oxlint-disable-next-line rules/require-route-crumb -- the crumb comes from the layout route
export const Route = createFileRoute("/(private)/library/plans/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <TemplateLibrary kind={TrainingPlanKind.PLAN} />;
}
